// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Table: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 19"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M.25.75h5v5h-5v-5zM.25 7h5v5h-5V7zm5 6.25v5h-5v-5h5zM6.5.75h5v5h-5v-5zm5 6.25v5h-5V7h5zm-5 6.25h5v5h-5v-5zM17.75.75v5h-5v-5h5zm-5 6.25h5v5h-5V7zm5 6.25v5h-5v-5h5z" />
        </svg>
    );
};

export default React.memo(Table);
